var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.31,461h-45.1c-26.59,0-50.66-22.7-67.8-63.92C180.67,359.2,172,309.1,172,256s8.67-103.2,24.41-141.08C213.55,73.7,237.62,51,264.21,51h45.1A30.53,30.53,0,0,1,340,81.3v67.47a30.53,30.53,0,0,1-30.69,30.3H260.82a436.67,436.67,0,0,0,0,153.86h48.49A30.53,30.53,0,0,1,340,363.23V430.7A30.53,30.53,0,0,1,309.31,461ZM264.21,75C232,75,196,149.33,196,256S232,437,264.21,437h45.1a6.51,6.51,0,0,0,6.69-6.3V363.23a6.51,6.51,0,0,0-6.69-6.3h-68l-2-9.46A434.09,434.09,0,0,1,230,256a434.09,434.09,0,0,1,9.28-91.47l2-9.46h68a6.51,6.51,0,0,0,6.69-6.3V81.3a6.51,6.51,0,0,0-6.69-6.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.71ea6115abb27feeda0af9ed0f5248ba.svg";
export { ForwardRef as ReactComponent };